import { ApiMethods, apiSenderV2, apiEndpoints } from 'src/utils/axios';

import { IDeviceItem } from 'src/store/SystemStore/types';

// Terminal Pairing Types
interface ClaimTerminalParams {
  pairingCode: string;
  businessLocationId?: string;
  terminalName?: string;
}

interface ClaimTerminalResponse {
  success: boolean;
  pairingId: string;
  terminalId?: string;
}

export const UpdateOrCreateDevice = async (data: IDeviceItem[], businessId: string) => {
  try {
    const result = await apiSenderV2(
      apiEndpoints.business.devices(businessId),
      ApiMethods.POST,
      {
        data,
      },
      true
    );
    console.log('AZED the result', result);
    return result as
      | ({ status: 'SUCCESS' | 'FAILED'; data: IDeviceItem[] } & { errorCode?: string })
      | null;
  } catch (error) {
    return null;
  }
};

export const addCompanionDevice = async (companionDeviceId: string) => {
  try {
    const result = await apiSenderV2(
      apiEndpoints.business.companionDevice,
      ApiMethods.POST,
      { companionDeviceId },
      true
    );
    if (result?.status === 'SUCCESS') {
      return result;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const claimTerminalPairingCode = async (
  params: ClaimTerminalParams
): Promise<ClaimTerminalResponse | null> => {
  try {
    const result = await apiSenderV2(
      apiEndpoints.devices.pairClaim(params.pairingCode),
      ApiMethods.POST,
      {
        businessLocationId: params.businessLocationId || undefined,
        terminalName: params.terminalName || undefined,
      },
      true
    );
    return result as ClaimTerminalResponse | null;
  } catch (error) {
    return null;
  }
};
